var _module_exports = "";;
var path = '/app/components/limited/limited.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;